import type { QueryObserverResult, RefetchOptions } from '@tanstack/react-query';
import TradingDatagridV3 from '@trading-ui/datagrid-v3';
import { useEffect, useRef } from 'react';
import { useResizeObserver } from 'usehooks-ts';

import TableLoader from '@/components/table-loader/TableLoader';

import type { ConsumptionChartResponse, ConsumptionTableResponse } from '@/interfaces';

import { useConsumptionTable } from './hooks/useConsumptionTable';

import * as styles from './ConsumptionTable.css';

type Props = {
  data: ConsumptionTableResponse;
  isLoading: boolean;
  mutateChart: (options?: RefetchOptions) => Promise<QueryObserverResult<ConsumptionChartResponse, Error>>;
  mutateTable: (options?: RefetchOptions) => Promise<QueryObserverResult<ConsumptionTableResponse, Error>>;
};

export default function ConsumptionTable({ data, isLoading, mutateChart, mutateTable }: Props) {
  const tableContainerRef = useRef<HTMLDivElement>(null);
  // @ts-ignore
  const { height = 0 } = useResizeObserver({ ref: tableContainerRef });
  const { theme, columns, options, tableInstance, getTableInstance } = useConsumptionTable({
    mutateChart,
    mutateTable,
    height,
  });

  useEffect(() => {
    if (tableInstance && data.consumptions.length > 0) {
      tableInstance.setData(data.consumptions);
    }
  }, [data.consumptions, tableInstance]);

  return (
    <div className={styles.root} ref={tableContainerRef}>
      {isLoading && <TableLoader />}
      {columns.length > 0 && height > 0 && (
        <TradingDatagridV3
          customId="consumption-table"
          getTableInstance={getTableInstance}
          columns={columns}
          theme={theme}
          data={[]}
          options={options}
        />
      )}
    </div>
  );
}
